import * as React from 'react';
import '@swc/helpers';
import '@grandvisionhq/utils';
import '../../../../../context/PaymentsUI/context.js';
import '@paypal/react-paypal-js';
import '@grandvisionhq/state';
import '../../../../../models/adyen/payment-type.js';
import '@grandvisionhq/icons';
import '../../../../../models/cart-payment-methods/cart-payment-methods.js';
import '../../../../../models/googlePay/types.js';
import '../../../../../models/payment/types.js';
import '../../../../../models/paypal/context.js';
import '@grandvisionhq/elements';
import '@grandvisionhq/forms';
import { SepaContainer } from '../../../containers/Adyen/Sepa/SepaContainer.js';

const Sepa = ({ onChange  })=>{
    const handleChange = React.useCallback((state)=>{
        onChange(state.data, state.isValid);
    }, [
        onChange
    ]);
    return /*#__PURE__*/ React.createElement(SepaContainer, {
        onChange: handleChange
    });
};

export { Sepa };
//# sourceMappingURL=Sepa.js.map
